import React from "react";
import {
    Sparkles,
    Wind,
    Users,
    BookOpen,
    Layers,
    Music,
} from "lucide-react";

const ITEMS = [
    { Icon: Sparkles, label: "Hypnotherapy" },
    { Icon: Wind, label: "Breathwork" },
    { Icon: Users, label: "Family Constellation" },
    { Icon: Music, label: "Sound Healing" },
    { Icon: BookOpen, label: "Soul Contract" },
    { Icon: Layers, label: "Tarot Guidance" },
];

export default function TrustStrip() {
    return (
        <section
            className="bg-[#FAF8F5] border-y border-[#EFEBE4]"
            data-testid="trust-strip"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-10 lg:py-12">
                <p className="ssh-eyebrow text-center mb-7">
                    Modalities woven into every session
                </p>
                <div className="grid grid-cols-3 sm:grid-cols-6 gap-y-8 gap-x-4">
                    {ITEMS.map(({ Icon, label }) => (
                        <div
                            key={label}
                            className="flex flex-col items-center gap-3 text-center"
                        >
                            <Icon
                                className="h-6 w-6 text-[#A68A6B]"
                                strokeWidth={1.25}
                            />
                            <p className="text-xs uppercase tracking-[0.18em] text-[#4A4947]">
                                {label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
